<script lang="ts">
	import { t, api } from "../../../stores";
	import { ShellChart, Peoples } from "@hitit/new_ui/src";
	import { formatISO } from "date-fns";
	import { onDestroy } from "svelte";
	export let storeIds: string[] = [];
	export let range = {
		start: new Date(),
		end: new Date(),
	};
	let ratio: [number, number] = [0, 0]; //new, return
	let count: [number, number] = [0, 0]; //new, return

	type ShellData = {
		name: string;
		count: number;
		color: string;
	};

	const colors = ["#6591fa", "#d8d9df"];
	const names = ["new", "return"];
	const x = (data: ShellData) => data.count;
	const innerRadius = 30;
	const gap = 15;
	const translateCount = (count: number, translate: string) => {
		return translate.replace("{count}", String(count));
	};

	let chart: SVGSVGElement;
	let graph: HTMLDivElement;
	let __resizeEvent__ = () => {};

	function getReport(range: { start: Date; end: Date }, storeId: string) {
		const { start, end } = range;
		return $api.getNumOfNewAndReVisitors({
			startTimeInTimeZone: formatISO(start),
			endTimeInTimeZone: formatISO(end),
			reportTimeZone: "ASIA_SEOUL",
			storeid: storeId,
		});
	}

	//Do
	//Do
	$: (async (__storeIds: string[], __range: { start: Date; end: Date }) => {
		try {
			const originStoreIds = storeIds;
			const originRange = range;

			const allRevenue = __storeIds.map((id) => getReport(__range, id));
			const promises = await Promise.all(allRevenue);
			//
			let totalCounts: [number, number] = [0, 0];
			if (originStoreIds !== __storeIds || originRange !== __range) {
				console.log("Canceld");
				return;
			}

			for (const response of promises) {
				const { newVisitor, reVisitor } = response.data;
				totalCounts[0] += newVisitor;
				totalCounts[1] += reVisitor;
			}
			let total = totalCounts[0] + totalCounts[1];

			count = [...totalCounts];
			ratio = totalCounts.map((v) => {
				if (total === 0) return 0;

				return Math.floor((v / total) * 100);
			}) as [number, number];
		} catch (error) {
			console.log(error);
		}
	})(storeIds, range);

	$: if (graph && count) {
		if (chart) {
			chart.remove();
			window.removeEventListener("resize", __resizeEvent__);
		}

		const mappedCount = count.map((v, i) => {
			return {
				name: names[i],
				count: v,
				color: colors[i],
			};
		});
		//
		const { node, resizeEvent } = ShellChart(graph, mappedCount, {
			x,
			gap,
			innerRadius,
			sorting: () => 1,
		});
		chart = node;
		__resizeEvent__ = resizeEvent;
	}
	onDestroy(() => window.removeEventListener("resize", __resizeEvent__));

</script>

<div class="container">
	<div class="title">
		<span>{$t('hub.dashboard.graph.Using_Point')}</span>
		<span>{$t('hub.dashboard.graph.New_returning_customer')}</span>
	</div>
	<div class="graph" bind:this={graph} style="height: 260px;">
		<div class="tip">
			<span class="icon">
				<Peoples />
			</span>
			<p class="total">{count[0] + count[1]}명</p>
		</div>
	</div>
	<div class="analysis">
		<div class="newvisit">
			<div class="by">{$t('hub.dashboard.graph.New_Customer')}</div>
			<div class="ratio">{ratio[0]}%</div>
			<div class="count">{translateCount(count[0], $t('global.x_people'))}</div>
		</div>
		<div class="seperate-bar" />
		<div class="revisit">
			<div class="by">{$t('hub.dashboard.graph.Return_Customer')}</div>
			<div class="ratio">{ratio[1]}%</div>
			<div class="count">{translateCount(count[1], $t('global.x_people'))}</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		gap: 20px;
		.title {
			display: flex;
			align-items: center;
			justify-content: center;
			widows: 100%;
			gap: 5px;
			font-weight: 550;
			color: #46474b;
		}
		.graph {
			position: relative;
			width: 100%;
			height: 260px;
			:global(svg) {
				position: relative;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			.tip {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				position: absolute;
				gap: 5px;
				transform: translate(-50%, -50%);
				top: 50%;
				left: 50%;
				max-width: 100%;
				max-height: 100%;
				.icon {
					/*  */
					width: 24px;
					height: 25.2px;
				}
				.total {
					font-size: 1.25rem;
					font-weight: 500;
					color: #46474b;
				}
			}
		}

		.analysis {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.newvisit,
			.revisit {
				display: flex;
				word-break: break-all;
				.ratio {
					font-weight: 500;
					flex-grow: 1;
					text-align: right;
				}
				.count {
					min-width: 4rem;
					text-align: right;
				}
			}

			.newvisit {
				color: #3c68d6;
			}

			.revisit {
				color: #6d6f76;
			}

			.seperate-bar {
				width: 100%;
				height: 1px;
				background-color: #d8d9de;
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 30px;
			gap: 30px;
			.title {
				flex-direction: column;
				font-size: 1.25rem;
			}
			.analysis {
				font-size: 1.25rem;
			}
			.graph {
				.tip {
					gap: 6px;
					.total {
						font-size: 1.5rem;
					}
				}
			}
		}
	}

</style>
